(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.animated-tick', ['pp.widgets-templates']);

ngModule.component('ppAnimatedTick', {
    templateUrl: 'widgets/_angular/animated-tick/animated-tick.tpl.html',
    transclude: true,
    bindings: {
        isChecked: '<',
        isDisabled: '<',
        isRound: '<?',
        isInverted: '<?'
    },
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);